let mobileMenuButton = document.querySelector('.jsMobileMenu');
if (mobileMenuButton) {
	mobileMenuButton.addEventListener('click', () => {
		let htmlElement = document.documentElement;
		// Close any open mega menus when closing the "parent" mobile menu
		let openMegaMenus = document.querySelectorAll('dialog.jsMegaMenu[open]');
		if (htmlElement.classList.contains('menu-shown')) {
			openMegaMenus.forEach(menu => {
				menu.close();
				let menuId = menu.id;

				let linkedButtons = document.querySelectorAll(`button[data-dialog-id="${menuId}"]`);
				linkedButtons.forEach(btn => btn.classList.remove('megamenu-active'));
				htmlElement.classList.remove('megamenu-shown');
			});
		}
		// Toggle the mobile menu
		htmlElement.classList.toggle('menu-shown');
	});
}

let closeMegaMenuButton = document.querySelector('button.jsCloseMegamenu');
let megamenuArray = document.querySelectorAll('dialog.jsMegaMenu');
if (closeMegaMenuButton) {
	closeMegaMenuButton.addEventListener('click', () => {
		// Remove open menu classes
		let htmlElement = document.documentElement;
		htmlElement.classList.remove('menu-shown');
		htmlElement.classList.remove('megamenu-shown');

		// Close all open mega menus
		megamenuArray.forEach(menu => {
			if (menu.hasAttribute('open')) {
				menu.close();
				let menuId = menu.id;

				let linkedButtons = document.querySelectorAll(`button[data-dialog-id="${menuId}"]`);
				linkedButtons.forEach(btn => btn.classList.remove('megamenu-active'));
			}
		});
	});
}